import { GridStatePayload } from '../models';
import { CLEAR_FILTER, UPDATE_GRID_STATE } from './actionTypes';
import { Action } from './commonActions';

export function updateGridState(payload: GridStatePayload) {
  return {
    type: UPDATE_GRID_STATE,
    payload,
  };
}

/**
 * Clears a grid filter
 * @param gridName The grid name
 */
export function clearGridFilter(gridName: string): Action<string> {
  return {
    type: CLEAR_FILTER,
    payload: gridName,
  };
}
